module.exports = __webpack_public_path__ + "static/logo_large-65992376a25cceb2481438b16d58c52d.svg";